const initialState = {
  fetching: false,
  fetched: false,
  organization: null,
  data: {
    slides: [],
    extraInfos: {}
  },
  attachmentFileLink: "",
  error: null
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_DASHBOARD": {
      return { ...initialState };
    }
    case "SET_DASHBOARD_ORGANIZATION": {
      return { ...state, organization: { ...action.organization } };
    }
    case "SET_ATTACHMENT_FILE_LINK": {
      return { ...state, attachmentFileLink: action.attachmentFileLink };
    }
    case "FETCH_DASHBOARD_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "SET_DASHBOARD_SLIDES": {
      return {
        ...state,
        data: {
          ...state.data,
          slides: action.slides
        }
      };
    }
    case "FETCH_DASHBOARD_FULFILLED": {
      const data = action.payload.data.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: data,
        organization: data.organization
      };
    }
    case "FETCH_DASHBOARD_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }
    default:
      return state;
  }
};

const initialGeneralAssociationDashboard = {
  fetching: false,
  fetched: false,
  error: null,
  created: [],
  standard: [],
  forms: []
};

export const generalAssociationDashboardReducer = (
  state = initialGeneralAssociationDashboard,
  action
) => {
  switch (action.type) {
    case "INIT_GENERAL_ASSOCIATION_DASHBOARD": {
      return initialGeneralAssociationDashboard;
    }
    case "FETCH_GENERAL_ASSOCIATION_DASHBOARD_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_GENERAL_ASSOCIATION_DASHBOARD_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        forms: action.payload.forms,
        created: action.payload.created,
        standard: action.payload.standard
      };
    }
    case "FETCH_GENERAL_ASSOCIATION_DASHBOARD_REJECTED": {
      return {
        ...state,
        fetching: false,
        error: action.payload
      };
    }
    case "SET_GENERAL_ASSOCIATION_DASHBOARD": {
      return {
        ...state,
        created: action.payload
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js